import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth-gurad-guard';
import { warehouseAccessGuard } from './core/auth/warehouse-access.guard';

export const routes: Routes = [
  {
    path: 'signin',
    title: 'Sign In',
    loadComponent: () =>
      import('./layout/unAuthorized/sign-in-component/sign-in-component').then(
        (m) => m.SignInComponent,
      ),
  },

  {
    path: 'select-workspace',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./layout/workspace-selector/workspace-selector.component').then(
        (m) => m.WorkspaceSelectorComponent,
      ),
  },
  {
    path: 'access-denied',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./layout/workspace-selector/access-denied.component').then(
        (m) => m.AccessDeniedComponent,
      ),
  },
  {
    path: 'warehouse',
    canActivate: [authGuard, warehouseAccessGuard],
    canActivateChild: [authGuard, warehouseAccessGuard],
    loadComponent: () =>
      import('./layout/warehouse/warehouse-layout.component').then(
        (m) => m.WarehouseLayoutComponent,
      ),
    loadChildren: () =>
      import('./layout/warehouse/warehouse.routes').then((m) => m.warehouseRoutes),
  },
  {
    path: '',
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    loadComponent: () =>
      import('./layout/authorized/authorized-component/authorized-component').then(
        (m) => m.AuthorizedComponent,
      ),
    loadChildren: () =>
      import('./layout/authorized/authorized.routes').then((m) => m.authorizedRoutes),
  },
  {
    path: '**',
    redirectTo: 'signin',
  },
];
